import React from 'react'
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Button from "../CustomButtons/Button.jsx";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CustomSelect from "../CustomInput/CustomSelect";
import Close from "@material-ui/icons/Close";
import LoaderComponent from "../Loader";

import changeExpiryDateModalStyle from "../../../assets/jss/user/changeExpiryDateModalStyle.jsx";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

const ChangeNotificationModal = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;

        this.state = {
            notification: this.props.notification
        };

        this.handleNotificationChange = this.handleNotificationChange.bind(this);

        this.notificationOptions = [
            {
                value: "Disabled",
                key: "0"
            },
            {
                value: "Optional",
                key: "optional"
            },
            {
                value: "Mandatory",
                key: "mandatory"
            }
        ];
    }
    handleNotificationChange(e, name){
        this.setState({
            [name]: e.target.value
        });
    }
    render() {
        const { classes, saving, confirmationMessage, labelText } = this.props;
        const { notification } = this.state;
        
        return (
            <Dialog
                classes={{
                    root: classes.modalRoot,
                    paper: classes.modal
                }}
                open={this.props.open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="confirmationModal-modal-slide-title"
                aria-describedby="confirmationModal-modal-slide-description"
            >
                <DialogTitle
                    id="confirmationModal-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    >
                        <Button
                            simple
                            className={classes.modalCloseButton+" "+classes.modalCloseButtonCustom}
                            key="close"
                            aria-label="Close"
                            onClick={() => this.props.onClose()}
                        >
                            {" "}
                            <Close className={classes.modalClose} />
                        </Button>
                        {
                            saving ?
                                <></>
                            :
                            <h4 className={classes.modalTitle+" "+classes.textCenter}>{confirmationMessage}</h4> 
                        }
                </DialogTitle>
                <DialogContent
                    id="confirmationModal-modal-slide-description"
                    className={classes.modalBody}
                    >
                        {
                            saving ?
                                <LoaderComponent color="custom" align="center" />
                            :
                            <>
                                <CustomSelect 
                                    formControlProps={{
                                        fullWidth: true,
                                        className: "custom-input m-zero"
                                    }}
                                    labelText={labelText}
                                    selectProps={{
                                        onChange: (e) => this.handleNotificationChange(e, 'notification'),
                                        value: notification
                                    }}
                                    inputProps={{
                                        name: "notification",
                                    }}
                                    color="custom"
                                    items={this.notificationOptions}
                                    itemLabel="value"
                                    itemValue="key"
                                />
                            </>
                        }
                </DialogContent>
                {
                    saving ?
                        <></>
                    :
                    <DialogActions className={classes.modalFooter +" " +classes.justifyContentCenter}>
                        <Button color="custom" className={classes.changeButton} onClick={() => this.props.onSuccess(notification)}>
                            Change
                        </Button>
                    </DialogActions>
                }
            </Dialog>
        )
    }
}

ChangeNotificationModal.defaultProps = {
    open: false,
    confirmationMessage: "",
    saving: false,
    labelText: "",
}
ChangeNotificationModal.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool,
    confirmationMessage: PropTypes.string,
    saving: PropTypes.bool,
    labelText: PropTypes.string,
}
export default withStyles(changeExpiryDateModalStyle)(ChangeNotificationModal);